import { callApi } from "./callApi";
import { ls } from "./storage";

function getOs(cb) {
  if (!window.hasGetOpenClassification) {
    callApi(
      "/api/hrm/classifiedProtection/getClassificationInfo4Component",
      "GET",
      {}
    )
      .then(res => {
        if (res.status) {
          const { isOpenClassification, resourceOptionInfo } = res;
          window.localStorage.setItem(
            "resourceOptionInfo",
            JSON.stringify(resourceOptionInfo)
          );
          window.localStorage.setItem(
            "isOpenClassification",
            isOpenClassification
          );
          window.hasGetOpenClassification = true;
        }
      })
      .catch(err => {
        // window.console && window.console.log('err: ', err);
      });
  }
  callApi("/api/system/info/getOSinfo", "GET", {})
    .then(res => {
      if (res.status) {
        ls.set("getOsInfo", res);
        const {
          defaultLinkMode,
          dragColumns,
          uploadSuffixLimit,
          prohibitDownload,
          languageVersion
        } = res;
        window.localStorage.setItem("ec_open_rewrite", defaultLinkMode);
        window.localStorage.setItem("dragColumns_WeaTable", dragColumns);
        window.localStorage.setItem("uploadSuffixLimit", uploadSuffixLimit);
        window.localStorage.setItem("prohibitDownload", prohibitDownload);
        window.localStorage.setItem("languageVersion", languageVersion);
      }
      const { browserConfig } = res;
      if (browserConfig) {
        const {
          timeInterval,
          typeList,
          defaultPageSize,
          pageConfigList,
          defaultCountry
        } = browserConfig;
        // 保存浏览按钮的设置
        window.ecBrowserConfig = browserConfig;
        // 获取浏览按钮显示设置
        window.ecBrowserDisplayStyle = typeList || [];
        // 获取系统时间间隔设置
        window.ecTimePickerMinuteStep = timeInterval || 1;
        // 获取浏览按钮默认显示条数
        window.ecBrowserDisplayPageSize = defaultPageSize || 10;
        // 获取浏览按钮显示条数配置
        window.ecBrowserDisplayConfigList = pageConfigList || [];
        // 获取城市浏览框默认国家配置
        window.ecBrowserDefaultCountry = defaultCountry;
      }
      cb();
    })
    .catch(err => {
      // window.console && window.console.log('err: ', err);
    });
  // window.localStorage.removeItem("ec_open_rewrite");
}
module.exports = getOs;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/getOsInfo.js